import request from "@/utils/request";

// 校验支付密码是否正确
export function verifyPay(data) {
  return request({
    url: "/ntocc-basic-api/pay/verify",
    method: "post",
    data: data
  });
}

//查询是否存在支付密码
// GET /pay/isexist
// 接口ID：273881884
// 接口地址：https://app.apifox.com/link/project/4415659/apis/api-273881884
export function isexistPSW(query) {
  return request({
    url: "/ntocc-basic-api/pay/isexist",
    method: "get",
    params: query
  });
}

//发送验证码
// POST /pay/sendVerificationCode
// 接口ID：273287722
// 接口地址：https://app.apifox.com/link/project/4415659/apis/api-273287722
export function sendVerificationCode(data) {
  return request({
    url: "/ntocc-basic-api/pay/sendVerificationCode",
    method: "post",
    params: data
  });
}

// 修改用户支付密码
//   POST /pay/update
//   接口ID：273287720
//   接口地址：https://app.apifox.com/link/project/4415659/apis/api-273287720
export function editPSW(data) {
  return request({
    url: "/ntocc-basic-api/pay/update",
    method: "post",
    data: data
  });
}

// 创建支付密码
//   POST /pay/create
//   接口ID：273287719
//   接口地址：https://app.apifox.com/link/project/4415659/apis/api-273287719
export function createPSW(data) {
  return request({
    url: "/ntocc-basic-api/pay/create",
    method: "post",
    data: data
  });
}
